import { motion } from 'framer-motion'
import { Button } from '../ui/Button'
import { SectionLabel } from '../ui/SectionLabel'

const steps = [
  {
    num: '01',
    title: '30-Min Discovery Call',
    body: "We learn about your business, your current setup, and your biggest frustrations. No tech jargon - just an honest conversation about where you are and where you want to go.",
  },
  {
    num: '02',
    title: 'Your Custom Roadmap',
    body: "We build a clear plan: what we'll manage, what we'll automate, what it costs. No hidden fees. You choose the plan that fits your team size and goals.",
  },
  {
    num: '03',
    title: 'We Handle Everything',
    body: "From day one, your tech is our responsibility. We onboard your team, migrate what needs moving, and you get back to running your business.",
  },
]

export function ProcessSteps() {
  return (
    <section id="process" style={{ padding: '120px 0', background: 'var(--bg)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          className="mb-16"
        >
          <SectionLabel className="mb-6">How It Works</SectionLabel>
          <h2
            style={{
              fontFamily: 'Barlow Condensed, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(40px, 5vw, 64px)',
              textTransform: 'uppercase',
              lineHeight: 1.0,
              maxWidth: 600,
              marginBottom: 72,
              color: 'var(--white)',
            }}
          >
            Three steps to <span style={{ color: 'var(--accent)' }}>hand off</span> your tech.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[3px] relative">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              initial={false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="process-step relative"
              style={{
                background: 'var(--bg-3)',
                padding: '52px 44px',
              }}
            >
              <div
                aria-hidden="true"
                style={{
                  fontFamily: 'Barlow Condensed, sans-serif',
                  fontSize: 86,
                  fontWeight: 900,
                  lineHeight: 1,
                  color: 'rgba(78,125,233,0.45)',
                  marginBottom: 4,
                  letterSpacing: '-0.02em',
                }}
              >
                {step.num}
              </div>
              <h3
                style={{
                  fontFamily: 'Barlow Condensed, sans-serif',
                  fontWeight: 800,
                  fontSize: 22,
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  marginBottom: 14,
                  color: 'var(--white)',
                }}
              >
                {step.title}
              </h3>
              <p
                style={{
                  fontSize: 16,
                  lineHeight: 1.7,
                  color: 'var(--white-dim)',
                }}
              >
                {step.body}
              </p>
              {i < steps.length - 1 && (
                <div
                  className="hidden md:block absolute"
                  style={{
                    top: 56,
                    right: -14,
                    width: 28,
                    height: 2,
                    background: 'var(--accent)',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      right: -8,
                      top: -4,
                      width: 0,
                      height: 0,
                      borderLeft: '8px solid var(--accent)',
                      borderTop: '5px solid transparent',
                      borderBottom: '5px solid transparent',
                    }}
                  />
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={false}
          animate={{ opacity: 1 }}
          className="text-center mt-16"
        >
          <Button to="/contact" variant="primary">
            Book Your Free Discovery Call
          </Button>
        </motion.div>
      </div>
    </section>
  )
}
